export default __webpack_public_path__ + "static/media/feature_4.c0db0213.png";